export default "__VITE_ASSET__CvgNBfp___"